module.exports = __webpack_public_path__ + "static/media/user-guide-3.558c581c.png";